import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowLeft } from "lucide-react";
import { Footer } from "@/components/site/Footer";

const EASE = [0.16, 1, 0.3, 1];

export default function LegalLayout({ eyebrow, title, updated, children }) {
  return (
    <main className="bg-charcoal min-h-screen" data-testid="legal-page">
      <header className="fixed top-0 left-0 right-0 z-50 bg-charcoal/85 backdrop-blur-xl border-b border-zinc-800">
        <div className="max-w-[1400px] mx-auto px-5 md:px-10 h-16 md:h-20 flex items-center justify-between">
          <Link to="/" className="flex items-center gap-2 group" data-testid="legal-logo">
            <span className="w-2.5 h-2.5 bg-ember rotate-45 group-hover:rotate-[135deg] transition-transform duration-500" />
            <span className="font-body text-lg md:text-xl font-semibold text-white">ReBarOS</span>
          </Link>
          <Link
            to="/"
            data-testid="legal-back-home"
            className="inline-flex items-center gap-2 font-body text-sm text-zinc-400 hover:text-ember transition-colors"
          >
            <ArrowLeft size={16} /> Back to site
          </Link>
        </div>
      </header>

      <section className="relative pt-36 md:pt-48 pb-16 border-b border-zinc-800 overflow-hidden">
        <div className="absolute top-0 right-0 w-[40vw] h-[400px] ember-glow opacity-50" aria-hidden="true" />
        <div className="relative max-w-3xl mx-auto px-5 md:px-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, ease: EASE }}
          >
            <div className="flex items-center gap-3 mb-6">
              <span className="w-8 h-px bg-ember" />
              <span className="font-body text-xs tracking-[0.35em] uppercase text-ember">{eyebrow}</span>
            </div>
            <h1 className="font-display font-black text-4xl md:text-6xl text-white leading-none">{title}</h1>
            <p className="font-body text-sm text-zinc-500 mt-6">Last updated: {updated}</p>
          </motion.div>
        </div>
      </section>

      <article className="max-w-3xl mx-auto px-5 md:px-10 py-16 md:py-24">
        <div className="legal-prose space-y-10">{children}</div>
      </article>

      <Footer />
    </main>
  );
}

export const Section = ({ heading, children }) => (
  <section data-testid="legal-section">
    <h2 className="font-cond font-bold text-2xl md:text-3xl uppercase tracking-wide text-white mb-4">
      {heading}
    </h2>
    <div className="font-body text-zinc-400 leading-relaxed space-y-4 text-[15px] md:text-base">
      {children}
    </div>
  </section>
);
